import endpoint from "../../config/endpoints";

export const TownJson = {
  showSaveNextBtn: true,
  formPath: "/town-form",
  apiBaseURL: endpoint.town,
  changeExcel: endpoint.exportData,
  screenTitle: "Town",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "Town",
  showExcelDownload: false,
  excelFileName: "Town",
  formPathView: "/town-view",
  isActiveURL: endpoint.town + "/update-is-active-status",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "isActive",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order Number",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrder",
      isMandatory: true,
    },
  ],
};
